module.exports = __webpack_public_path__ + "static/home6-1d8de16072f59d601345a51f80afde70.jpg";